// import React, { useState } from 'react';
// import './navbar.css';
// import logo from '../assets/logo2.1.png';
// import { Link } from 'react-router-dom';
// import { FaInstagram, FaYoutube, FaBars } from 'react-icons/fa';

// const Navbar = () => {
//   const [menu, setMenu] = useState("home");
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

//   // Toggle mobile menu visibility
//   const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

//   const handleNavClick = (menuItem) => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth',
//     });

//     setMenu(menuItem);
//     setIsMobileMenuOpen(false);
//   };

//   return (
//     <div className="navbar">
//       {/* Top Navbar (Logo, Email, Phone, Social Icons) */}
//       <div className="navbar-top">
//         <div className="nav-logo">
//           <img src={logo} alt="Logo" />
//           <p>MANDI HARIYANA Academy</p>
//         </div>
//         <div className="top-right">
//           <div className="contact-info">
//             <p className="email">Email: info@mhacademy.com</p>
//             <p className="phone">Phone: +123 456 7890</p>
//           </div>
//           <div className="social-icons">
//             <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
//               <FaInstagram className="social-icon" />
//             </a>
//             <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer">
//               <FaYoutube className="social-icon" />
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Navbar (Navigation Links) */}
//       <div className="navbar-bottom">
//         <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
//           <FaBars className="menu-icon" />
//         </div>
//         <ul className={`nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
//           <li onClick={() => handleNavClick("home")}>
//             <Link to="/">Home</Link>
//             {menu === "home" && <span className="underline"></span>}
//           </li>
//           <li onClick={() => handleNavClick("courses")}>
//             <Link to="/courses">Courses</Link>
//             {menu === "courses" && <span className="underline"></span>}
//           </li>
//           <li onClick={() => handleNavClick("about")}>
//             <Link to="/about">About Us</Link>
//             {menu === "about" && <span className="underline"></span>}
//           </li>
//           <li onClick={() => handleNavClick("campus")}>
//             <Link to="/campus">Campus</Link>
//             {menu === "campus" && <span className="underline"></span>}
//           </li>
//           <li onClick={() => handleNavClick("contact")}>
//             <Link to="/contact">Contact Us</Link>
//             {menu === "contact" && <span className="underline"></span>}
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// }

// export default Navbar;

import React, { useState, useEffect } from 'react';
import './navbar.css';
import logo from '../assets/logo2.1.png';
import { Link } from 'react-router-dom';
import { FaInstagram, FaYoutube, FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [menu, setMenu] = useState("home");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const handleNavClick = (menuItem) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setMenu(menuItem);
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`main-navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        
        {/* Logo goes to home and resets menu state */}
        <Link to="/" className="navbar-brand" onClick={() => handleNavClick("home")}>
          <img src={logo} alt="Mandi Hariyanna Academy" />
          <div className="brand-text">
            <span className="brand-title">MANDI HARIYANNA Academy</span>
            <span className="brand-subtitle">Mandi Harish Foundation&reg;</span>
          </div>
        </Link>

        <div className="mobile-toggle" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={`nav-links ${isMobileMenuOpen ? 'open' : ''}`}>
          <li onClick={() => handleNavClick("home")}>
            <Link to="/" className={menu === "home" ? "active" : ""}>Home</Link>
            {menu === "home" && <span className="underline"></span>}
          </li>
          <li onClick={() => handleNavClick("courses")}>
            <Link to="/courses" className={menu === "courses" ? "active" : ""}>Courses</Link>
            {menu === "courses" && <span className="underline"></span>}
          </li>
          <li onClick={() => handleNavClick("about")}>
            <Link to="/about" className={menu === "about" ? "active" : ""}>About Us</Link>
            {menu === "about" && <span className="underline"></span>}
          </li>
          <li onClick={() => handleNavClick("campus")}>
            <Link to="/campus" className={menu === "campus" ? "active" : ""}>Campus</Link>
            {menu === "campus" && <span className="underline"></span>}
          </li>
          <li onClick={() => handleNavClick("Placement")}>
            <Link to="/Placement" className={menu === "Placement" ? "active" : ""}>Placement</Link>
            {menu === "Placement" && <span className="underline"></span>}
          </li>
          <li onClick={() => handleNavClick("contact")}>
            <Link to="/contact" className={menu === "contact" ? "active" : ""}>Contact Us</Link>
            {menu === "contact" && <span className="underline"></span>}
          </li>
        </ul>

        <div className="navbar-right">
          <div>
            <p><a href="mailto:mhskill2024@gmail.com">mhskill2024@gmail.com</a></p>
            <p><a href="tel:+919113647474">+91 9113647474</a></p>
          </div>
          <div className="social-icons">
            <a href="https://www.instagram.com/reel/DLg-u1SSs-C/?igsh=NHc5Njl4NmN2aW5r" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="https://youtu.be/LSD-qYSgBDk?si=6btEdssDcM1QTm9" target="_blank" rel="noreferrer">
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;